import React, {Component} from 'react';
import './Sponsor.scss';

class SponsorPeersona extends Component{
    render() {
        return (
            
            <div className = "container">
                <img class = "gambar" src="/images/Pict/peersona.png" alt= "logo peersona" width="950" height="100"  />
                <div class="tulisan">
                <p align= "justify">  
                <b>Peersona</b> is an AI-powered hiring assistant focusing on ABCs; Applicants, Business, and Community.
                We help global enterprises and candidates gain a competitive advantages by implementing scientifically validated pre-employment assessments. Using a video resume and matchmaking algorithm creating best and memorable hiring process both for business and candidates.

                Peersona is Indonesian based startup IT specialized in artificial intelligence and computer visions.
                </p>
                </div>   
            </div>
            
        )
    }
}
export default SponsorPeersona;